import { FilterFilled } from "@ant-design/icons";
import { buildFilters } from "../../../../helpers/utilityHelpers";
import { getNumericValue } from "../utils/eventFormatters";
import classes from "./StoreEventModal.module.scss";

const filterIcon = <FilterFilled className={classes.FilterIcon} />;

export const getStoreColumns = (storeRows) => [
  {
    title: "",
    dataIndex: "position",
    key: "position",
    align: "center",
    width: "10%",
  },
  {
    title: "Itens resgatados",
    dataIndex: "item",
    key: "item",
    width: "58%",
    filters: buildFilters(storeRows, "item"),
    filterIcon,
    onFilter: (value, record) => record.item === value,
    sorter: (a, b) => a.item.localeCompare(b.item),
  },
  {
    title: "Resgates",
    dataIndex: "redemptions",
    key: "redemptions",
    width: "32%",
    filters: buildFilters(storeRows, "redemptions"),
    filterIcon,
    onFilter: (value, record) => record.redemptions === value,
    sorter: (a, b) =>
      getNumericValue(a.redemptions) - getNumericValue(b.redemptions),
  },
];
